import { createLucideIcon } from 'lucide-react';
export const LanguageIcon = createLucideIcon('language-icon', [
  [
    'path',
    {
      d: 'M12.45 6.15H10.65',
      key: 'ob54yr',
    },
  ],
  [
    'path',
    {
      d: 'M13.8 18.75V17.4L16.05 12L18.3 17.4V18.75',
      key: '1bys5n',
    },
  ],
  [
    'path',
    {
      d: 'M14.25 16.5H17.925',
      key: '1dgp7r',
    },
  ],
  [
    'path',
    {
      d: 'M16.2353 7.7647H21V21H7.7647V16.2353',
      key: '1m6t8j',
    },
  ],
  [
    'path',
    {
      d: 'M16.2353 7.7647L7.7647 16.2353',
      key: 'tpa86z',
    },
  ],
  [
    'path',
    {
      d: 'M16.2353 7.7647V3H3V16.2353H7.7647',
      key: '3epwpj',
    },
  ],
  [
    'path',
    {
      d: 'M5.7 6.15H8.85',
      key: '1thr55',
    },
  ],
  [
    'path',
    {
      d: 'M8.5 10.5C8 11 7.3859 11.55 6.6 11.55C6.15 11.55 6.15 11.55 5.7 11.55',
      key: '2dqs10',
    },
  ],
  [
    'path',
    {
      d: 'M8.5 10.5C8.5 10.5 7.95 10.2 7.5 9.75C7.3495 9.5995 7.5 9.75 7.05 9.3C6.6772 8.9272 6.6 8.4 6.6 7.95',
      key: '13y578',
    },
  ],
  [
    'path',
    {
      d: 'M8.5 10.5C8.5 10.5 9.1676 9.8744 9.75 8.85C10.2177 8.0273 10.65 6.15 10.65 6.15',
      key: '1hn7d8',
    },
  ],
  [
    'path',
    {
      d: 'M8.5 10.5C8.5 10.5 9.357 10.65 9.75 10.65C10.2 10.65 10.65 10.65 10.65 10.65H11.1',
      key: '1puv2l',
    },
  ],
  [
    'path',
    {
      d: 'M8.85 6.15H10.65',
      key: '1angn5',
    },
  ],
  [
    'path',
    {
      d: 'M8.85 6.15V4.8',
      key: 'if6vdw',
    },
  ],
]);
